import React, { useState } from "react";
import Arabic from "../../components/terms/Arabic";
import English from "../../components/terms/English";
import { useRouter } from "next/router";
import Head from "next/head";
export default function index() {
  const router = useRouter;
  const [lang, setLang] = useState(router.locale);
  return (
    <div>
      <Head>
        <title>Ascot - Terms & Conditions</title>
      </Head>
      <Arabic />
      <English />
    </div>
  );
}

export async function getServerSideProps({ query, locale }) {
  return {
    props: {
      locale,
      messages: require(`../../locales/${locale || "en"}.json`),
    },
  };
}
